/* ==========================================================================
   SOLVARO — rails, ruban, apparition, remontées.
   - un seul contrôleur pour tous les rails (flèches, points, défilement auto)
   - [data-sv-to-buy] : ramène en douceur jusqu'à la zone d'achat
   - [data-sv-top]    : bouton « haut de page », visible après un écran
   Aucune dépendance. Écouteurs passifs.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__solvaro) return;
  window.__solvaro = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MAX_DOTS = 8;

  function behavior() { return REDUCED.matches ? 'auto' : 'smooth'; }

  /* ---------------------------------------------------------------- RAIL */

  function Rail(root) {
    this.root = root;
    this.track = root.querySelector('[data-sv-track]');
    this.prev = root.querySelector('[data-sv-prev]');
    this.next = root.querySelector('[data-sv-next]');
    this.dots = root.querySelector('[data-sv-dots]');
    if (!this.track) return;

    this.pages = 0;
    this.autoDelay = parseInt(root.getAttribute('data-sv-autoplay') || '0', 10);
    this.timer = null;
    this.paused = false;

    this.track.addEventListener('scroll', debounce(this.sync.bind(this), 60), { passive: true });
    if (this.prev) this.prev.addEventListener('click', this.step.bind(this, -1));
    if (this.next) this.next.addEventListener('click', this.step.bind(this, 1));
    window.addEventListener('resize', debounce(this.build.bind(this), 150));

    this.build();
    this.setupAuto();
  }

  /* Largeur d'une carte plus l'écart — mesurée, jamais estimée. */
  Rail.prototype.stepWidth = function () {
    var first = this.track.firstElementChild;
    if (!first) return this.track.clientWidth;
    var gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
    return first.getBoundingClientRect().width + gap;
  };

  Rail.prototype.overflows = function () {
    return this.track.scrollWidth > this.track.clientWidth + 4;
  };

  Rail.prototype.build = function () {
    var on = this.overflows();
    [this.prev, this.next].forEach(function (b) {
      if (!b) return;
      b.hidden = !on;
      b.tabIndex = on ? 0 : -1;
    });
    if (this.dots) {
      this.dots.hidden = !on;
      if (on) this.renderDots();
      else this.dots.innerHTML = '';
    }
    if (on) this.sync();
  };

  Rail.prototype.renderDots = function () {
    var pages = Math.ceil(this.track.scrollWidth / this.track.clientWidth);
    pages = Math.max(1, Math.min(pages, MAX_DOTS));
    if (pages === this.pages && this.dots.children.length === pages) return;
    this.pages = pages;

    var frag = document.createDocumentFragment();
    for (var i = 0; i < pages; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sv-rail__dot';
      b.setAttribute('aria-label', 'Vai al gruppo ' + (i + 1) + ' di ' + pages);
      b.dataset.svIndex = String(i);
      frag.appendChild(b);
    }
    this.dots.innerHTML = '';
    this.dots.appendChild(frag);

    var self = this;
    this.dots.onclick = function (e) {
      var d = e.target.closest('.sv-rail__dot');
      if (!d) return;
      self.pause();
      var max = self.track.scrollWidth - self.track.clientWidth;
      var target = (Number(d.dataset.svIndex) / (self.pages - 1 || 1)) * max;
      self.track.scrollTo({ left: target, behavior: behavior() });
      self.repaint();
    };
  };

  Rail.prototype.step = function (dir) {
    this.pause();
    var max = this.track.scrollWidth - this.track.clientWidth;
    var left = this.track.scrollLeft + dir * this.stepWidth();
    this.track.scrollTo({ left: Math.max(0, Math.min(left, max)), behavior: behavior() });
    this.repaint();
  };

  Rail.prototype.repaint = function () {
    var self = this;
    setTimeout(function () { self.sync(); }, 80);
    setTimeout(function () { self.sync(); }, 450);
  };

  Rail.prototype.sync = function () {
    var t = this.track;
    var max = t.scrollWidth - t.clientWidth;
    var atStart = t.scrollLeft <= 1;
    var atEnd = t.scrollLeft >= max - 2;

    if (this.prev && !this.prev.hidden) this.prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    if (this.next && !this.next.hidden) this.next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    if (!this.dots || this.dots.hidden || !this.pages) return;

    var i = atEnd ? this.pages - 1 : Math.round((t.scrollLeft / (max || 1)) * (this.pages - 1));
    for (var k = 0; k < this.dots.children.length; k++) {
      this.dots.children[k].setAttribute('aria-current', k === i ? 'true' : 'false');
    }
  };

  Rail.prototype.setupAuto = function () {
    if (!this.autoDelay || REDUCED.matches) return;
    var self = this;

    /* Le premier geste du visiteur arrête le défilement pour de bon. */
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      self.root.addEventListener(ev, function () { self.pause(); }, { passive: true });
    });
    this.root.addEventListener('mouseenter', function () { self.hold = true; });
    this.root.addEventListener('mouseleave', function () { self.hold = false; });
    this.root.addEventListener('focusin', function () { self.pause(); });
    document.addEventListener('visibilitychange', function () { self.hold = document.hidden; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
      }, { threshold: 0.35 }).observe(this.root);
    } else {
      this.visible = true;
    }

    this.timer = setInterval(function () {
      if (self.paused || self.hold || !self.visible || !self.overflows()) return;
      var max = self.track.scrollWidth - self.track.clientWidth;
      if (self.track.scrollLeft >= max - 2) self.track.scrollTo({ left: 0, behavior: 'smooth' });
      else self.track.scrollBy({ left: self.stepWidth(), behavior: 'smooth' });
      self.repaint();
    }, this.autoDelay);
  };

  Rail.prototype.pause = function () {
    this.paused = true;
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  };

  /* --------------------------------------------------------------- RUBAN */

  function ribbon(root) {
    root.addEventListener('click', function () { root.classList.toggle('is-paused'); });
    root.addEventListener('mouseenter', function () { root.classList.add('is-paused'); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); });
  }

  /* ---------------------------------------------------------- APPARITION */

  function reveal() {
    var items = document.querySelectorAll('.sv-rise:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || REDUCED.matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var i = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--sv-delay', Math.min(i, 5) * 70 + 'ms');
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------- REMONTER À L'ACHAT */

  /* La zone d'achat est la section « main » du gabarit produit. On vise le
     bouton d'ajout s'il existe, sinon le haut de la section, sinon la page. */
  function buyTarget() {
    return document.querySelector('.product-add-to-cart-button') ||
           document.querySelector('[id^="shopify-section-template"][id$="__main"]');
  }

  function scrollToBuy(e) {
    var link = e.target.closest('[data-sv-to-buy]');
    if (!link) return;
    e.preventDefault();
    var t = buyTarget();
    if (!t) { window.scrollTo({ top: 0, behavior: behavior() }); return; }
    var headerH = (document.querySelector('header') || { offsetHeight: 0 }).offsetHeight || 0;
    var y = t.getBoundingClientRect().top + window.scrollY - headerH - 24;
    window.scrollTo({ top: Math.max(0, y), behavior: behavior() });
  }

  /* ------------------------------------------------------ HAUT DE PAGE */

  /* Fiche BIB-64 : invisible = `hidden` (jamais cliquable en transparence),
     posé à la fin du fondu ; après la remontée, le focus revient en haut. */
  var TOP_AT = 600;

  function toTop() {
    var btn = document.querySelector('[data-sv-top]');
    if (!btn || btn.__sv) return;
    btn.__sv = true;
    var on = false;

    function show() {
      if (on) return;
      on = true;
      btn.hidden = false;
      void btn.offsetWidth; /* reflow : le fondu part bien de l'état caché */
      btn.classList.add('is-on');
    }
    function hide() {
      if (!on) return;
      on = false;
      btn.classList.remove('is-on');
      if (REDUCED.matches) { btn.hidden = true; return; }
      setTimeout(function () { if (!on) btn.hidden = true; }, 340);
    }

    var onScroll = function () { if (window.scrollY > TOP_AT) show(); else hide(); };
    window.addEventListener('scroll', debounce(onScroll, 60), { passive: true });
    onScroll();

    btn.addEventListener('click', function () {
      var ms = glideTo(0);
      var dest = document.querySelector('main h1') || document.querySelector('h1') || document.querySelector('main');
      if (!dest) return;
      if (!dest.hasAttribute('tabindex')) dest.setAttribute('tabindex', '-1');
      setTimeout(function () { dest.focus({ preventScroll: true }); }, ms + 20);
    });
  }

  /* Remontée animée, dessinée par le script : le défilement « smooth » du
     navigateur saute d'un coup quand le système réduit les animations
     (réglage fréquent sous Windows). Durée selon la distance, 450-900 ms,
     un geste du visiteur (molette, doigt, clavier) l'interrompt. */
  function glideTo(y) {
    var start = window.scrollY || window.pageYOffset;
    var dist = y - start;
    if (!dist) return 0;
    var ms = Math.max(450, Math.min(900, Math.abs(dist) * 0.35));
    var t0 = null, stop = false;
    var cancel = function () { stop = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, cancel, { passive: true, once: true });
    });
    var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    var step = function (ts) {
      if (stop) return;
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / ms);
      window.scrollTo(0, Math.round(start + dist * ease(p)));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
    return ms;
  }

  /* ------------------------------------------------- GALERIE COLLANTE */

  /* Le script de compatibilité MoonBundle pose `overflow: auto !important`
     en ligne sur html et body quand son tiroir est fermé : body devient un
     conteneur de défilement et la galerie `position: sticky` ne suit plus.
     On retire uniquement ce `auto` ; le `hidden` du tiroir ouvert reste.
     Son observateur ne surveille pas `style`, donc aucune boucle. */
  function freeScroll() {
    var root = document.documentElement;
    var fix = function (el) {
      if (el && el.style.getPropertyValue('overflow') === 'auto') el.style.removeProperty('overflow');
    };
    var run = function () { fix(root); fix(document.body); };
    var mo = new MutationObserver(run);
    mo.observe(root, { attributes: true, attributeFilter: ['style'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['style'] });
    run();
  }

  /* La galerie se cale sous l'en-tête collant, pas dessous. Le thème lit
     `--header-height` dans sa règle sticky ; on la pose sur la galerie
     seule, jamais sur :root (l'en-tête s'en sert pour sa propre hauteur). */
  function headerOffset() {
    var h = document.querySelector('.section-header') || document.querySelector('header');
    var m = document.querySelector('.product-section__medias--sticky');
    if (!h || !m) return;
    var set = function () {
      var sticky = getComputedStyle(h).position === 'sticky';
      m.style.setProperty('--header-height', (sticky ? h.offsetHeight : 0) + 'px');
    };
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(h);
    set();
  }

  /* -------------------------------------------------------------- OUTILS */

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function boot() {
    document.querySelectorAll('[data-sv-rail]').forEach(function (el) {
      if (el.__svRail) return;
      el.__svRail = new Rail(el);
    });
    document.querySelectorAll('[data-sv-ribbon]').forEach(function (el) {
      if (el.__svRibbon) return;
      el.__svRibbon = true;
      ribbon(el);
    });
    reveal();
    toTop();
  }

  document.addEventListener('click', scrollToBuy);

  function init() { freeScroll(); headerOffset(); boot(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
